// extracted by mini-css-extract-plugin
export default {"OverlayContainer":"ModalOverlay_OverlayContainer__5xrs5","Container":"ModalOverlay_Container__aG3-S","CloseIcon":"ModalOverlay_CloseIcon__DwK13"};